import { render, staticRenderFns } from "./AdminBlastNotification.vue?vue&type=template&id=4e05923e&scoped=true"
import script from "./AdminBlastNotification.vue?vue&type=script&lang=js"
export * from "./AdminBlastNotification.vue?vue&type=script&lang=js"
import style0 from "./AdminBlastNotification.vue?vue&type=style&index=0&id=4e05923e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e05923e",
  null
  
)

export default component.exports